<div class="modal-box">
  <h2 class="modal-title">
    {{
      "admin.userStatusModal.title"
        | translate: { action: (actionKey | translate) }
    }}
  </h2>

  <p>
    {{
      "admin.userStatusModal.confirmation"
        | translate: { action: (actionKey | translate | lowercase) }
    }}
  </p>

  <div class="modal-actions">
    <button (click)="cancel.emit()" class="btn-cancel">
      {{ "admin.userStatusModal.cancel" | translate }}
    </button>
    <button (click)="confirm.emit()" class="btn-confirm">
      {{ actionKey | translate }}
    </button>
  </div>
</div>
